import { render } from "./AppFooter.vue?vue&type=template&id=162dd217&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=162dd217&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-162dd217"

export default script